import { render, staticRenderFns } from "./PlatformConfigList.vue?vue&type=template&id=470259a9&scoped=true"
import script from "./PlatformConfigList.vue?vue&type=script&lang=js"
export * from "./PlatformConfigList.vue?vue&type=script&lang=js"
import style0 from "./PlatformConfigList.vue?vue&type=style&index=0&id=470259a9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470259a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('470259a9')) {
      api.createRecord('470259a9', component.options)
    } else {
      api.reload('470259a9', component.options)
    }
    module.hot.accept("./PlatformConfigList.vue?vue&type=template&id=470259a9&scoped=true", function () {
      api.rerender('470259a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/PlatformConfigList.vue"
export default component.exports